"use strict";

exports.__esModule = true;
exports.capitalize = exports.AdvancedTimelineValueElement = void 0;
var _path2 = _interopRequireDefault(require("ramda/src/path"));
var _react = _interopRequireDefault(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _Utils = require("../../../Utils");
var _Translator = require("../../Core/Translator");
var _DeviceColorSources = require("../../Device/DeviceColorSources");
var _DeviceContext = require("../../Device/DeviceContext");
var _TextValue = require("../../Measures/TextValue");
var _Timer = require("../../Time/Timer");
var _TimelineSubscription = require("../../Timeline/TimelineSubscription");
var _common = require("../common");
var _TileContext = require("../common/TileContext");
var _excluded = ["value", "backgroundColor"],
  _excluded2 = ["value"],
  _excluded3 = ["timeline", "dimensions"],
  _excluded4 = ["timeline", "dimensions"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var capitalize = exports.capitalize = function capitalize(val) {
  if (/^-?[0-9]*[.]?[0-9]*$/.test(val)) {
    return val;
  }
  return (0, _Utils.capitalizeWords)((val || "").toString().split(/[,_.-]/));
};
var TextRenderer = function TextRenderer(_ref) {
  var value = _ref.value,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? "transparent" : _ref$backgroundColor,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  var tile = _react["default"].useContext(_TileContext.TileContext) || {};
  var width = extra.width,
    height = extra.height;

  // Inside a device card the value is a line: a state dot and the text.
  if (tile.flat) {
    var dot = backgroundColor !== "transparent" ? backgroundColor : "#c7cfd5";
    return /*#__PURE__*/_react["default"].createElement(_TileContext.FlatRow, _extends({
      style: {
        width: width,
        height: height
      }
    }, (0, _common.getWidgetInteractionProps)(extra)), tile.role === "state" && /*#__PURE__*/_react["default"].createElement(_TileContext.FlatDot, {
      style: {
        background: dot
      }
    }), /*#__PURE__*/_react["default"].createElement(_TileContext.FlatText, null, value));
  }
  return /*#__PURE__*/_react["default"].createElement(_TextValue.TextValue, _extends({}, (0, _common.getWidgetFontProps)(extra), (0, _common.getWidgetInteractionProps)(extra), {
    value: value,
    width: width,
    height: height,
    backgroundColor: backgroundColor
  }));
};
var getFormattedValue = function getFormattedValue(timelineEvent, now) {
  if (!timelineEvent) {
    return "";
  }
  var timestamp = timelineEvent.timestamp;
  var maxValue = Math.max(_moment["default"].utc(timestamp).valueOf(), now);
  var durationVal = maxValue - _moment["default"].utc(timestamp).valueOf();
  return (0, _Utils.formatDuration)(durationVal, true);
};
var TimelineValue = function TimelineValue(_ref2) {
  var value = _ref2.value,
    extra = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  var device = _react["default"].useContext(_DeviceContext.DeviceContext);
  return /*#__PURE__*/_react["default"].createElement(_DeviceColorSources.DeviceColorController, _extends({}, extra, {
    deviceUuid: device.uuid,
    value: value
  }), function (_ref3) {
    var backgroundColor = _ref3.backgroundColor;
    return /*#__PURE__*/_react["default"].createElement(TextRenderer, _extends({}, extra, {
      value: value,
      backgroundColor: backgroundColor
    }));
  });
};
var TimelineDurationValue = function TimelineDurationValue(props) {
  var device = _react["default"].useContext(_DeviceContext.DeviceContext);
  // eslint-disable-next-line
  var timeline = props.timeline,
    dimensions = props.dimensions,
    extra = _objectWithoutPropertiesLoose(props, _excluded3);
  return /*#__PURE__*/_react["default"].createElement(_Timer.Timer, {
    interval: 1000
  }, function (_ref4) {
    var now = _ref4.now,
      restartTimer = _ref4.restartTimer;
    return /*#__PURE__*/_react["default"].createElement(_TimelineSubscription.AdvancedTimelineSubscription, {
      device: device.uuid,
      timeline: timeline,
      onData: restartTimer,
      kind: timeline === "condition" ? "condition" : "timeline"
    }, function (data) {
      return /*#__PURE__*/_react["default"].createElement(TimelineValue, _extends({
        value: getFormattedValue(data, now)
      }, extra));
    });
  });
};
var AdvancedTimelineValueElement = exports.AdvancedTimelineValueElement = function AdvancedTimelineValueElement(props) {
  var timeline = props.timeline,
    dimensions = props.dimensions,
    extra = _objectWithoutPropertiesLoose(props, _excluded4);
  var device = _react["default"].useContext(_DeviceContext.DeviceContext);
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var noTimelineText = translate("AdvancedTimelineValue.element.noTimelineSelected", "Select Timeline");
  var noDimensionText = translate("AdvancedTimelineValue.element.noDimensionSelected", "Select Dimension");
  if (!timeline) {
    return /*#__PURE__*/_react["default"].createElement(TextRenderer, _extends({}, extra, {
      value: noTimelineText
    }));
  }
  if (!dimensions || !dimensions[0]) {
    return /*#__PURE__*/_react["default"].createElement(TextRenderer, _extends({}, extra, {
      value: noDimensionText
    }));
  }
  var isNotOfTypeDuration = dimensions[0] !== "duration";
  if (isNotOfTypeDuration) {
    return /*#__PURE__*/_react["default"].createElement(_TimelineSubscription.AdvancedTimelineSubscription, {
      device: device.uuid,
      timeline: timeline,
      kind: timeline === "condition" ? "condition" : "timeline"
    }, function (data) {
      var value = (0, _path2["default"])(dimensions[0].split("."), data) || "";
      return /*#__PURE__*/_react["default"].createElement(TimelineValue, _extends({
        value: capitalize(value)
      }, extra));
    });
  }
  return /*#__PURE__*/_react["default"].createElement(TimelineDurationValue, _extends({}, extra, {
    timeline: timeline,
    dimensions: dimensions
  }));
};